import 'reflect-metadata'
import React, { useEffect, useLayoutEffect, useRef } from 'react'
import { RootNavigation } from './src/navigation/_root'
import { ATLThemeProvider } from '@appsimples/atlantica-react-native'
import { atlTheme } from './src/atlTheme'
import { intlMessages } from './src/constants/strings/intl'
import { useLocales } from './src/constants/strings/intl/useLocale'
import { addLocaleData, IntlProvider } from 'react-intl'
import { InjectIntlContext } from './src/constants/strings/intl/intlHooks'
import SplashScreen from 'react-native-splash-screen'
import locale_en from 'react-intl/locale-data/en'
import locale_pt from 'react-intl/locale-data/pt'
import { initializeApolloClient } from './src/services/apolloClient'
import { ContainerProvider } from './src/container'
import { useGlobal, useLoadPersistedState } from './src/global/useGlobal'
import { setDeviceToken } from './src/services/main/pushService'
import { syncUser } from './src/services/main/syncUser'
import { usePromise } from './src/utils/hooks/usePromise'
import { SnackbarWeb } from './src/components/snackbar/web/Snackbar'

addLocaleData([...locale_en, ...locale_pt])
const initializeApp = () => {
  SplashScreen?.hide()
  initializeApolloClient()
}

export default function App() {
  const locales = useLocales()
  const intlLocale = (locales.bestAvailableLanguage && locales.bestAvailableLanguage.languageTag) || 'en'
  const [authToken] = useGlobal('authToken')
  const [userId] = useGlobal('uid')
  const authTokenRef = useRef()
  const userIdRef = useRef()
  const { request: sync, loading: loadingSyncUser } = usePromise(syncUser)

  // load persistent data
  const loadingPersistedState = useLoadPersistedState()

  const appLoading = loadingPersistedState

  useEffect(() => {
    if (authToken) {
      setDeviceToken()
    }
  }, [authToken])

  useEffect(() => {
    if (authToken && !authTokenRef.current && userId !== userIdRef.current) {
      console.log('Syncing user information')
      sync()
    }
    userIdRef.current = userId
    authTokenRef.current = authToken
  }, [authToken, userId])

  // Initialize App once app is no longer loading
  useLayoutEffect(() => {
    if (!appLoading) {
      initializeApp()
    }
  }, [appLoading])

  if (appLoading) {
    return false
  }

  return (
    <ContainerProvider>
      <IntlProvider
        locale={intlLocale}
        defaultLocale={'en'}
        messages={intlMessages[intlLocale]}
        key={intlLocale}
        onError={console.warn}
      >
        <InjectIntlContext>
          <ATLThemeProvider theme={atlTheme as any}>
            <RootNavigation isLogged={!!authToken} />
            <SnackbarWeb />
          </ATLThemeProvider>
        </InjectIntlContext>
      </IntlProvider>
    </ContainerProvider>
  )
}
